import { EditFilled } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { Link, useParams } from "react-router-dom";

type Props = {
  page: number;
  pageSize: number;
};

const GeneralEdit = (props: Props) => {
  const { page, pageSize } = props;
  const { id } = useParams();

  return (
    <div className="flex flex-col gap-3">
      <Link
        to={`/betting-websites/edit-title/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Title
        </Button>
      </Link>
      <Link
        to={`/betting-websites/edit-short-description/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Short Description
        </Button>
      </Link>
      <Link
        to={`/betting-websites/edit-long-description/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Long Description
        </Button>
      </Link>
      <Link
        to={`/betting-websites/edit-q-and-a/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Question & Answers
        </Button>
      </Link>
      <Link
        to={`/betting-websites/edit-ratings/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Rating
        </Button>
      </Link>
      <Link
        to={`/betting-websites/edit-contacts/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Contacts
        </Button>
      </Link>

      <Link
        to={`/betting-websites/edit-languages/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Languages
        </Button>
      </Link>

      <Link
        to={`/betting-websites/edit-payment-gateways/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Payment Gateways
        </Button>
      </Link>

      <Link
        to={`/betting-websites/edit-features/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Features
        </Button>
      </Link>
      <Link
        to={`/betting-websites/edit-image/${id}?page=${
          page + 1
        }&pageSize=${pageSize}`}
      >
        <Button block size="large" type="dashed" icon={<EditFilled />}>
          {" "}
          Edit Image
        </Button>
      </Link>
    </div>
  );
};

export default GeneralEdit;
